
import { ApplicationUserModel, TenantIpRestrictionModel, IpRestrictionTypeEnum } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { ipRestrictionsStore } from '@/libs/tenant-ip-restrictions/+state/store';
import axios from 'axios';
import apiService from '@/libs/core/api-service';
@Component({})
export default class TenantIpRestrictionDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    ipRestriction: TenantIpRestrictionModel | null = null;
    deleteDialog = false;
    deleting = false;
    myPublicIp: string | null = null;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.ipRestriction?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        this.myPublicIp = null;
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadTenantIpRestriction()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.ipRestriction = {
                id: Guid.EmptyGuid(),
                ip: '',
                ipRestrictionType: IpRestrictionTypeEnum.QuickLogin,
            } as TenantIpRestrictionModel;
            this.getMyPublicIP();
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadTenantIpRestriction() {
        return new Promise((resolve, reject) => {
            ipRestrictionsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(ipRestrictionsStore, CrudReponse.Get)
                .then((e) => {
                    this.ipRestriction = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const ipRestriction = { ...this.ipRestriction };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                ipRestrictionsStore.dispatch(CrudAction.Create, { item: ipRestriction });
                this.subscribe(ipRestrictionsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                ipRestrictionsStore.dispatch(CrudAction.Update, { item: ipRestriction });
                this.subscribe(ipRestrictionsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteTenantIpRestriction() {
        this.deleting = true;
        ipRestrictionsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(ipRestrictionsStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }

    getMyPublicIP() {
        apiService.api.getMyIp().then((e) => {
            this.myPublicIp = e.data.ip ?? '';
        });
    }

    setMyPublicIp() {
        this.ipRestriction!.ip = this.myPublicIp;
    }
}
